import { useState } from 'react';
import { useToast, useTranslator } from '@front-activerse/common-components';
import { Row, Col, Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { formatIsoDate } from '@front-activerse/common-components';
import Calendar from '../../Calendar/Calendar';
import { useOutletContext } from 'react-router-dom';

const MIN_DATE_DAYS_IN_FUTURE = 0;

const InsertToDayPlan = ({
  lastAvailableDay,
  insertFavoriteToDayplan,
  mealId,
  showInsertDate,
  closeInsertDate,
}) => {
  const { toastSuccess, toastError } = useToast();
  const { t } = useTranslator();
  const { trackFirebaseEvent } = useOutletContext();

  const [showAlertModal, setShowAlertModal] = useState(false);
  const [errorTitle, setErrorTitle] = useState('');
  const [errorDesscription, setErrorDesscription] = useState('');
  const [errorSkipable, setErrorSkipable] = useState(false);
  const [activeDate, setActiveDate] = useState(undefined);
  const [showCalendar, setShowCalendar] = useState(false);
  const [savedMealId, setSavedMealId] = useState(undefined);

  const toggleAlertModal = () => {
    setShowAlertModal(!showAlertModal);
  };

  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
  };

  const getMaxDate = () => {
    const now = new Date();
    const dateLastAvailableDay = new Date(lastAvailableDay);
    const diffTime = Math.abs(dateLastAvailableDay - now);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const handleInsertToDayplan = async (date, skipValidation, addToDietTimeId) => {
    setActiveDate(date);
    setShowAlertModal(false);
    setSavedMealId(undefined);

    trackFirebaseEvent('user_action', {
      action: 'tap-add_to_diet_time',
      meal_id: mealId,
      add_to_diet_time: addToDietTimeId,
    });

    if (date) {
      try {
        let response;
        if (savedMealId) {
          response = await insertFavoriteToDayplan(date, savedMealId, skipValidation);
          setSavedMealId(undefined);
        } else {
          response = await insertFavoriteToDayplan(date, mealId, skipValidation);
        }

        if (response.data.me.insertFavoriteToDayplan.__typename === 'BasicMutationSuccessWithId') {
          toastSuccess(<p>{t('mealPlan.favorites.notification.addedToMenu.content')}</p>);

          trackFirebaseEvent('screen_view', {
            firebase_screen: 'Favourites_added',
            meal_id: mealId,
          });
        } else if (
          response.data.me.insertFavoriteToDayplan.__typename ===
          'InsertToDayPlanValidationException'
        ) {
          const { skipable, title, description } = response.data.me.insertFavoriteToDayplan;

          setShowAlertModal(true);
          setErrorTitle(title);
          setErrorDesscription(description);
          setErrorSkipable(skipable);
          if (skipable) {
            setSavedMealId(mealId);
          }
        }
      } catch (error) {
        toastError();
        throw new Error(`Failed to insert meal to dayplan: ${error}`);
      }
    }

    closeInsertDate();
  };

  const tomorrowDate = new Date();
  tomorrowDate.setDate(tomorrowDate.getDate() + 1);

  return (
    <>
      <Calendar
        min={MIN_DATE_DAYS_IN_FUTURE}
        max={getMaxDate()}
        resetDateAfterOk
        showCalendar={showCalendar}
        toggleCalendar={toggleCalendar}
        getPickedDay={(day) => {
          handleInsertToDayplan(day, false, 1);
        }}
      />

      <Modal isOpen={showInsertDate} fullscreen={true} size="lg" toggle={() => closeInsertDate()}>
        <div className="select-insert-date">
          <p className="mb-0">{t('mealPlan.favorites.mealDetails.addToMenu.bottomSheet.title')}</p>
          <hr className="my-2" />
          <Button
            color="white"
            size="sm"
            onClick={() => handleInsertToDayplan(formatIsoDate(new Date()), false, 0)}
            className="w-100"
          >
            {t('mealPlan.favorites.mealDetails.addToMenu.bottomSheet.today')}
          </Button>
          <hr className="my-2" />
          <Button
            color="white"
            size="sm"
            onClick={() => handleInsertToDayplan(formatIsoDate(tomorrowDate), false, 1)}
            className="w-100"
          >
            {t('mealPlan.favorites.mealDetails.addToMenu.bottomSheet.tomorrow')}
          </Button>
          <hr className="my-2" />

          <Button color="white" size="sm" className="w-100" onClick={toggleCalendar}>
            {t('mealPlan.favorites.mealDetails.addToMenu.bottomSheet.date')}
          </Button>
        </div>
      </Modal>

      <Modal
        isOpen={showAlertModal}
        toggle={toggleAlertModal}
        centered
        size="lg"
        className="favourites"
      >
        <ModalBody>
          <h4 className="title-medium semi-bold">{errorTitle}</h4>
          <p className="text-text-variant-color">{errorDesscription}</p>
        </ModalBody>
        <ModalFooter>
          {errorSkipable ? (
            <Row className="w-100">
              <Col xs="6" className="pr-2">
                <Button
                  color="secondary"
                  className="w-100"
                  outline
                  onClick={() => toggleAlertModal()}
                >
                  {t('mealPlan.favorites.addToMenu.warning.cancelButton')}
                </Button>
              </Col>
              <Col xs="6" className="pl-2">
                <Button
                  color="primary"
                  className="w-100"
                  onClick={() => handleInsertToDayplan(activeDate, true, 2)}
                >
                  {t('mealPlan.favorites.addToMenu.warning.includeButton')}
                </Button>
              </Col>
            </Row>
          ) : (
            <Button color="primary" className="w-100" onClick={() => toggleAlertModal()}>
              {t('mealPlan.favorites.addToMenu.error.closeButton')}
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </>
  );
};

export default InsertToDayPlan;
